module.exports = __webpack_public_path__ + "static/img/4.5c8fa79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/4.png
// module id = 58uK
// module chunks = 0